import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import { fetchApi } from '@/config/axiosSetting';
import { DriverPersonalInfoType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchPersonalDriverData/driverPersonalInfoQuery.type';

export const driverPersonalInfoQueryFunction = (
  params: DriverPersonalInfoType,
) => {
  const formattedParams = {
    ...params.data,
    birthdate: convertPersianToGregorian(
      params?.data?.birthdate?.toString() ?? '',
    ),
  };

  return fetchApi.patch(
    `/property/reports/${params?.id}/accident_users/damaged/user_information/driver/personal_information/`,
    formattedParams,
    {
      params: {
        damaged_id: params?.damaged_id,
      },
    },
  );
};
